import hoistNonReactStatic from 'hoist-non-react-statics';
import React, { useEffect, useState } from 'react';

const getDisplayName = (Component) => Component.displayName || Component.name || 'Component';

export default function withPostponedRender(Component) {
  function WrappedComponent(props) {
    const [wasPostponed, setWasPostponed] = useState(false);

    useEffect(() => {
      setWasPostponed(true);
    }, []);
    return wasPostponed ? <Component { ...props } /> : null;
  }

  hoistNonReactStatic(WrappedComponent, Component);
  WrappedComponent.displayName = `WrappedComponent(${getDisplayName(Component)})`;
  return WrappedComponent;
}
